<template>
  <div class="homeContainer">
    <head-top></head-top>
    <div class="carouselDiv">
      <el-carousel height="600px" :autoplay="true">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <div class="bannerDiv">
            <img :src="item" alt=""/>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="noticeDiv">
        <div class="noticeContent contentWidth flex-start">
          <span class="loginIcon notice"></span>
          <span v-for="(item, index) in noticeList.filter((item2, index2) => {return index2 < 3})" :key="index" class="noticeTitle" @click="toDetails(index)">[{{item.time}}]{{item.title}}</span>
          <div class="moreBtn flex-start">
            <span @click="toNoticeList">更多公告</span>
            <span class="loginIcon more"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="loginDiv contentWidth">
      <div class="loginContent" v-if="status === 1">
        <p>账号登录</p>
        <el-form>
          <el-input v-model="form.userName" placeholder="登录账号">
            <i slot="prefix" class="loginIcon user"></i>
          </el-input>
          <el-input v-model="form.passWord" type="password" placeholder="登录密码">
            <i slot="prefix" class="loginIcon psd"></i>
          </el-input>
        </el-form>
        <div class="flex-start">
          <el-input v-model="form.verifyCode" placeholder="验证码" class="verifyInput" @keyup.enter.native="toLogin">
            <i slot="prefix" class="loginIcon check"></i>
          </el-input>
          <img :src="validCodeUrl" alt="图形验证码" @click="getValidCode" v-loading="loadingValid" class="validImg"/>
          <span class="changeCode" @click="getValidCode">换一张</span>
        </div>
        <el-button type="primary" @click="toLogin" :loading="loginLoading" class="loginBtn" :disabled="disabledLogin">登录</el-button>
        <div class="forgetPswBtn" @click="resetPsw">忘记密码</div>
      </div>

      <div class="forgetPsw" v-else-if="status === 2">
        <i class="el-icon-back rollBack" @click="status = 1; resetForm = $options.data().resetForm"></i>
        <p>忘记密码</p>
        <el-form label-width="80px" :rules="forgetRule" ref="resetForm" :model="resetForm">
          <el-form-item label="登录账号:" prop="userName">
            <el-input v-model="resetForm.userName" placeholder="请输入登录账号"></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="mobile">
            <el-input v-model="resetForm.mobile" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="验证码:">
            <el-input v-model="resetForm.mobileVerifyCode" style="width: 120px" placeholder="请输入验证码"></el-input>
            <el-button style="width: 110px; padding: 12px 20px; margin-left: 10px" type="primary" :disabled="disabledSend" @click="sendCode('resetForm')">{{ btntext }}</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="checkCode" :loading="loginLoading" class="loginBtn" @keyup.enter.native="toLogin" :disabled="nextStep">下一步</el-button>
      </div>

      <div class="forgetPsw" v-else-if="status === 3">
        <i class="el-icon-back rollBack" @click="status = 1; resetForm = $options.data().resetForm"></i>
        <p style="margin-bottom: 15px">重置密码</p>
        <el-form label-width="85px" label-position="top" :rules="forgetRule" ref="resetForm" :model="resetForm">
          <el-form-item label="新密码:" prop="newPassWord">
            <el-input v-model="resetForm.newPassWord" type="password" placeholder="8-20位大写/小写字母/数字/符号至少三种组合"></el-input>
          </el-form-item>
          <el-form-item label="确认密码:" prop="confirmPassWord">
            <el-input v-model="resetForm.confirmPassWord" type="password" placeholder="8-20位大写/小写字母/数字/符号至少三种组合"></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="submitForm('resetForm')" :loading="loginLoading" class="loginBtn" @keyup.enter.native="toLogin" style="margin-top: 0">确认</el-button>
      </div>

      <div class="forgetPsw" v-else>
        <i class="el-icon-success successIcon" style="font-size: 60px; color: #33cc00;"></i>
        <h5>重置成功</h5>
        <el-button type="primary" @click="status = 1" class="loginBtn backBtn" style="margin-top: 0">返回登录页</el-button>
      </div>
    </div>
<!--    <p class="tips">{{$store.state.footerText}}</p>-->
    <div class="resolvePlan contentWidth">
      <p class="resolveTitle">解决方案</p>
      <p class="subTitle">提供全方位支付+营销解决方案</p>
      <div class="resolveList flex-start">
        <resolve-item v-for="(item, index) in resolveList.filter((item2, index2) => {return index2 < 3})" :item="item" :index="index" :key="index"></resolve-item>
      </div>
      <div class="moreBtn flex-center">
        <span @click="$router.push('resolve')">更多方案</span>
        <span class="loginIcon more"></span>
      </div>
    </div>
    <foot-btm></foot-btm>
  </div>
</template>

<script>
import defaultImage from '../../assets/image/img-default.jpg'
import headTop from '@/components/layout/headTop'
import footBtm from '@/components/layout/footBtm'
import resolveItem from '@/views/home/resolveItem'
const Mock = require('mockjs')
const md5 = require('md5')
export default {
  name: 'index',
  components: {
    headTop,
    resolveItem,
    footBtm
  },
  data () {
    var validateUserName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入登录账号'))
      } else {
        callback()
      }
    }
    var validateMobile = (rule, value, callback) => {
      const regMobile = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else {
        if (regMobile.test(value)) {
          return callback()
        }
        callback(new Error('请输入正确的手机号'))
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        const regPassword = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z_\W]+$)(?![a-z\d]+$)(?![a-z_\W]+$)(?![\d_\W]+$)[^\u4e00-\u9fa5\s]{8,20}$/
        if (regPassword.test(value)) {
          this.$refs.resetForm.validateField('confirmPassWord')
          return callback()
        }
        callback(new Error('密码为8-20位大写/小写字母/数字/符号中的至少三种组合'))
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.resetForm.newPassWord) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      bannerList: [
        require('@/assets/image/banner.png'),
        require('@/assets/image/banner2.png'),
        require('@/assets/image/banner3.png')
      ],
      noticeList: [],
      form: {
        userName: '',
        passWord: '',
        verifyCode: '',
        verifyCodeSess: ''
      },
      resetForm: {
        userName: '',
        mobile: '',
        mobileVerifyCode: '',
        newPassWord: '',
        confirmPassWord: '',
        passSession: ''
      },
      validCodeUrl: defaultImage, // 图形验证码
      loadingValid: false,
      loginLoading: false,
      resolveList: [],
      status: 1,
      disabledSend: false,
      time: 60,
      btntext: '发送验证码',
      forgetRule: {
        userName: [
          { validator: validateUserName, trigger: 'blur' }
        ],
        mobile: [
          { validator: validateMobile, trigger: 'blur' }
        ],
        newPassWord: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        confirmPassWord: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    disabledLogin () {
      if (this.form.userName === '' ||
        this.form.passWord === '' ||
        this.form.verifyCode === '' ||
        this.form.verifyCodeSess === '') {
        return true
      } else {
        return false
      }
    },
    nextStep () {
      if (this.resetForm.userName === '' ||
        this.resetForm.mobile === '' ||
        this.resetForm.mobileVerifyCode === '') {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.getValidCode()
    this.getNotice()
    this.getResolve()
  },
  methods: {
    getValidCode () {
      if (this.loadingValid) {
        return
      }
      this.loadingValid = true
      this.$axios.get(this.$api.getValidCode).then(res => {
        this.loadingValid = false
        if (res.respCode === '0') {
          // this.validCodeUrl = res.middleUrl ? res.middleUrl.replace('http://', 'https://') : ''
          this.validCodeUrl = res.ssl_middle_url
          this.form.verifyCodeSess = res.sess
        }
      })
    },
    toLogin () {
      if (this.disabledLogin) {
        this.$message({
          type: 'warning',
          message: '请填写完整信息！'
        })
        return
      }
      this.loginLoading = true
      const params = Object.assign({}, this.form, {
        passWord: md5(this.form.passWord)
      })
      this.$axios.post(this.$api.login, params).then(res => {
        if (res.respCode === '0') {
          localStorage.setItem('LS_SAAS_CMS_SESSIONID', res.sessionId)
          this.$store.state.visitedViews.splice(0, this.$store.state.visitedViews.length)
          this.$store.dispatch('getUserInfo').then(() => {
            this.$router.push('/')
          })
        } else {
          this.loginLoading = false
          this.getValidCode()
        }
      })
    },
    toNoticeList () {
      this.$router.push({
        name: 'notice'
      })
    },
    getNotice () {
      this.noticeList = Mock.mock(require('@/mock/json/notice')).noticeList
    },
    toDetails (index) {
      this.$router.push({
        name: 'noticeDetails',
        query: {
          index: index
        }
      })
    },
    getResolve () {
      this.resolveList = Mock.mock(require('@/mock/json/resolve')).resolveList
    },
    resetPsw () {
      this.status = 2
    },
    sendCode (resetForm) {
      this.$refs[resetForm].validate((valid) => {
        if (valid) {
          const params = {
            userName: this.resetForm.userName,
            mobile: this.resetForm.mobile
          }
          this.$axios.post(this.$api.sendVailCode, params).then(res => {
            if (res.respCode === '0') {
              this.$message({
                message: '发送成功',
                type: 'success'
              })
              this.time = 60
              this.timer()
            }
          })
        } else {
          this.$message({
            message: '请完善信息后再发送！',
            type: 'warning'
          })
        }
      })
    },
    timer () {
      if (this.time > 0) {
        this.disabledSend = true
        this.time--
        this.btntext = this.time + '秒'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btntext = '发送验证码'
        this.disabledSend = false
      }
    },
    checkCode () {
      const params = {
        userName: this.resetForm.userName,
        mobile: this.resetForm.mobile,
        mobileVerifyCode: this.resetForm.mobileVerifyCode
      }
      this.$axios.post(this.$api.checkVailCode, params).then(res => {
        if (res.respCode === '0') {
          this.resetForm.passSession = res.data.passSession
          this.status = 3
        }
      })
    },
    submitForm (resetForm) {
      this.$refs[resetForm].validate((valid) => {
        if (valid) {
          const params = {
            userName: this.resetForm.userName,
            mobile: this.resetForm.mobile,
            newPassWord: md5(this.resetForm.newPassWord),
            passSession: this.resetForm.passSession
          }
          this.$axios.post(this.$api.forgetPsw, params).then(res => {
            if (res.respCode === '0') {
              this.resetForm = this.$options.data().resetForm
              this.status = 4
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.homeContainer{
  background: #f7f8fb;
  height: 100%;
  position: relative;
  overflow: auto;
  .carouselDiv{
    position: relative;
    .noticeDiv{
      position: absolute;
      bottom: 0;
      height: 70px;
      width: 100%;
      z-index: 10;
      background: #fff;
      .noticeContent{
        height: 70px;
        font-size: 14px;
        .notice{
          width: 21px;
          height: 18px;
          background-position: -10px -10px;
          margin-right: 20px;
          &:hover{
            background-position: -51px -10px;
          }
        }
        .noticeTitle{
          width: 291px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #333333;
          margin-right: 74px;
          cursor: pointer;
          &:hover{
            color: var(--main-color);
          }
        }
        .moreBtn{
          margin-left: -24px;
          color: var(--main-color);
          cursor: pointer;
          .more{
            width: 8px;
            height: 12px;
            background-position: -92px -47px;
            margin-left: 3px;
          }
        }
      }
    }
  }
  .bannerDiv{
    width: 100%;
    overflow: hidden;
    img{
      width: 1920px;
      margin-left: calc(50% - 960px);
      display: block;
    }
  }
  .loginIcon{
    display: inline-block;
    background: url("../../assets/image/login_sprites.png") no-repeat;
  }
  .tips{
    width: 100%;
    font-size: 14px;
    color: #999;
    margin-top: 34px;
    text-align: center;
  }
  .loginDiv{
    position: absolute;
    background: transparent;
    top: 130px;
    z-index: 11;
    left: 0;
    right: 0;
    .loginContent{
      width: 360px;
      height: 420px;
      padding: 40px 35px 59px 35px;
      box-sizing: border-box;
      background: #fff;
      float: right;
      border-radius: 6px;
      p{
        font-size: 20px;
        color: #000;
        font-weight: bold;
        margin-bottom: 28px;
      }
      .el-input{
        margin-bottom: 19px;
      }
      i{
        margin-top: 13px;
        margin-left: 17px;
      }
      .loginIcon.user{
        width: 16px;
        height: 18px;
        background-position: -10px -48px;
      }
      .loginIcon.psd{
        width: 16px;
        height: 17px;
        background-position: -92px -10px;
      }
      .loginIcon.check{
        width: 15px;
        height: 17px;
        background-position: -46px -48px;
      }
      .verifyInput{
        width: 130px;
        margin-right: 9px;
        margin-bottom: 0;
      }
      .validImg{
        width: 100px;
        height: 46px;
        margin-right: 8px;
        cursor: pointer;
      }
      .changeCode{
        color: var(--main-color);
        cursor: pointer;
      }
      .loginBtn{
        width: 100%;
        height: 46px;
        margin-top: 40px;
      }
      .forgetPswBtn {
        color: #d9001b;
        float: right;
        margin-top: 20px;
        cursor: pointer;
      }
    }
    .forgetPsw {
      width: 360px;
      height: 420px;
      padding: 20px 20px 59px;
      box-sizing: border-box;
      background: #fff;
      float: right;
      border-radius: 6px;
      p{
        font-size: 20px;
        color: #000;
        font-weight: bold;
        margin: 20px 0 28px;
      }
      .loginBtn{
        width: 100%;
        height: 46px;
        margin-top: 30px;
      }
      .rollBack {
        font-size: 20px;
        cursor: pointer;
      }
      .successIcon {
        margin: 25% 50% 10%;
        transform: translate(-50%);
      }
      .backBtn {
        display: block;
        width: 50%;
        margin-left: 50%;
        transform: translate(-50%);
      }
      h5 {
        display: inline-block;
        margin: 0 0 20% 50%;
        transform: translate(-50%);
      }
    }
  }
  .resolvePlan{
    text-align: center;
    padding-top: 88px;
    .resolveTitle{
      font-size: 40px;
      margin-bottom: 18px;
    }
    .subTitle{
      color: #8B8B8B;
      font-size: 22px;
      margin-bottom: 59px;
    }
    .resolveList{
      flex-wrap: wrap;
      margin-bottom: 60px;
    }
    .moreBtn{
      margin: 0 auto;
      color: var(--main-color);
      cursor: pointer;
      .more{
        width: 8px;
        height: 12px;
        background-position: -92px -47px;
        margin-left: 3px;
      }
    }
  }
}
</style>
<style lang="less">
.el-carousel__indicators--horizontal{
  position: absolute;
  bottom: 90px;
  .el-carousel__button{
    width: 16px;
    background: #dbdbdb;
  }
  .el-carousel__indicator{
    &.is-active{
      .el-carousel__button{
        background: #1677ff;
      }
    }
  }
}
.loginContent{
  .el-input{
    .el-input__inner{
      height: 46px;
      line-height: 46px;
      color: #000;
      font-size: 14px;
      padding-left: 50px;
    }
  }
}
</style>
